import
  React
from 'react';

import {
  Base,
  Image
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

import {
  useHistory
} from 'react-router-dom';

export const RoundInfoButton = () => {

  const history = useHistory();

  return (

    <Base
      position='fixed'
      display='block'
      justifyContent='center'
      alignItems='center'
      right='21px'
      bottom='20px'
      width='64px'
      height='64px'
      backgroundColor={CustomColors.White}
      borderRadius='50%'
      boxShadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}>

      <Base
        left='0'
        top='0'
        margin='0 0 0 auto'
        width='18px'
        height='18px'
        backgroundColor={CustomColors.Red2}
        borderRadius='50%'
        boxShadow={'0 2px 4px 0 rgba(0, 0, 0, 0.5)'}/>

      <Base
        width='100%'
        display='flex'
        justifyContent='center'
        alignItems='center'>

        <Image
          width='30px'
          height='30px'
          color={CustomColors.Black}
          src={Icons.Insight}
          onClick={() => {

            history.push({
              pathname: '/whats-new'
            });
          }} />
      </Base>
    </Base>
  );
};
